import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import Button from '@mui/material/Button';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
//
import { useCanViewAsStudent } from './use-can-view-as-student';

// ----------------------------------------------------------------------

// "View as student" for one student (#605) — renders nothing unless the
// signed-in super admin can use it here.
export default function ViewAsStudentButton({ asn, sx }) {
  const canViewAsStudent = useCanViewAsStudent();
  const { startImpersonation } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const [starting, setStarting] = useState(false);

  if (!canViewAsStudent || !asn) return null;

  const handleClick = async () => {
    setStarting(true);
    try {
      await startImpersonation(String(asn));
    } catch (error) {
      enqueueSnackbar(error?.message || 'Could not view as this student', { variant: 'error' });
      setStarting(false);
    }
  };

  return (
    <Button
      variant="outlined"
      color="warning"
      disabled={starting}
      startIcon={<Iconify icon="solar:user-id-bold" />}
      onClick={handleClick}
      sx={sx}
    >
      View as student
    </Button>
  );
}

ViewAsStudentButton.propTypes = {
  asn: PropTypes.string,
  sx: PropTypes.object,
};
